export enum Theme {
    LIGHT = 'theme.light',
    DARK = 'theme.dark',
    SYSTEM = 'theme.system'
}
